// extracted by mini-css-extract-plugin
export default {"link":"GEg7Vx","root":"rSzO7o","label":"P74wIG"};